import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import { PMNModeleAdmin, ProduitProposePMNDTO } from './models/PMNModele'
import globalMixin from '../../globalMixin'
import { PMNModeleLight } from './models/PMNModeleLight'
import { PMNModele_Input, PMNModele_Input_Proposition } from '@/domain/PMNModele'
import _ from 'lodash'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'

export default mixins(routeMixin, globalMixin, mobileTypeMixin).extend({
    data: function() {
        return {
            modeles: [],
            modeleEditeId: null as null | number,
            modeleEdite: null as null | PMNModeleAdmin,
            clientsModeleEdite: null as null | string[],
            companyName: null as null | string,
            produitAdded: '',
        }
    },
    methods: {
        loadModeles() {
            this.$loader.go()
            this.$http
                .api(`administrationPMN/all`)
                .get()
                .then(x => {
                    this.modeles = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadModeleEdite() {
            this.$loader.go()
            this.$http
                .api(`administrationPMN?id=${this.modeleEditeId}`)
                .get()
                .then(x => {
                    this.modeleEdite = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadAllProduitsInDatabase(){
            if(this.$database.produits.length == 0){
                this.$http
                    .api('administrationPMN/all-produits')
                    .get()
                    .then(x => {
                        this.$database.feed({ produits: x.data })
                        this.$database.save()
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            }
        },
        ajouterModele: function() {
            this.modeleEdite = new PMNModeleAdmin()
        },
        editModele: function(item: PMNModeleLight) {
            this.modeleEditeId = item.id
            this.loadModeleEdite()
        },
        deleteModele: function(item: PMNModeleLight) {
            this.$swal.confirm.delete().then((a) => {
                if(!a.isConfirmed) return;

                this.$http
                    .api(`AdministrationPMN`)
                    .deleteWithData(item.id)
                    .then(() => {
                        this.$swal.toast.success()
                        this.loadModeles()
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            })
        },
        ajouterUnChamp() {
            this.modeleEdite?.inputs.push(new PMNModele_Input())
        },
        ajouterProposition(input: PMNModele_Input) {
            input.propositions.push(new PMNModele_Input_Proposition())
        },
        supprimerProposition(input: PMNModele_Input, index: number) {
            input.propositions.splice(index, 1)
        },
        supprimerChamp(index: number) {
            if (this.modeleEdite) {
                this.modeleEdite.inputs.splice(index, 1)
            }
        },
        save() {
            if (!this.modeleEdite) return

            this.$http
                .api(`AdministrationPMN`)
                .post(this.modeleEdite)
                .then(() => {
                    this.$swal.toast.success()
                    this.loadModeles()
                    this.modeleEdite = null
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        cancel() {
            this.modeleEdite = null
        },
        onAjoutProduit(){
            if(this.produitAdded){
                const produit = _.find(this.$database.produits, (p) => p.codeArticle == this.produitAdded);
                if(produit && this.modeleEdite) {
                    const produitPropose = new ProduitProposePMNDTO();
                    produitPropose.codeArticle = produit.codeArticle;
                    produitPropose.nom = produit.nom;

                    this.modeleEdite.produitsProposes.push(produitPropose);
                }
                this.produitAdded = '';
            }
        },
        supprimerProduit(index: number){
            if(this.modeleEdite){
                this.modeleEdite.produitsProposes.splice(index, 1);
            }
        }
    },
    computed : {
        produits: function(): {text: string, value: string}[]{
            return _.map(this.$database.produits, (produit) => {
                return {
                    text: produit.nom,
                    value: produit.codeArticle
                }
            });
        }
    },
    mounted() {
        this.loadModeles()
        this.loadAllProduitsInDatabase()
    }
})
